/* ============
 * Country Transformer
 * ============
 *
 * The transformer for the country.
 */

import Transformer from './transformer';

export default class CountryTransformer extends Transformer {

  static fetch(country) {
    return {
      id: country.id,
      name: country.name,
      code: country.code,
    };
  }

  static send(country) {
    return {
      id: country.id,
      name: country.name,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/country.js